import api from "./api";

export const trimmingService = {
  getAllTrimmings: (page = 1, limit = 10) => api.get(`/trimming?page=${page}&limit=${limit}`),
  getTrimmingById: (id) => api.get(`/trimming/${id}`),
  createTrimming: (data) => api.post("/trimming", data),
  updateTrimming: (id, data) => api.put(`/trimming/${id}`, data),
  deleteTrimming: (id) => api.delete(`/trimming/${id}`),
};

